module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/projects-familymovies-moviefamilies.json
// module id = 362
// module chunks = 99754057209326